import { Component } from "react";
import Configuration from "./../../../config";

export default class Button extends Component {
  constructor(props) {
    super(props);

    this.onClick = this.onClick.bind(this);
    this.onDoubleClick = this.onDoubleClick.bind(this);
    this.disallowClick = this.disallowClick.bind(this);
  }

  disallowClick() {
    const self = this;
    self.justClicked = true;
    setTimeout(function () {
      self.justClicked = false;
    }, Configuration.ACTION_CLICK_TIMEOUT);
  }

  onClick(evt) {
    if (!this.justClicked) {
      this.disallowClick();
      this.props.onClick && this.props.onClick(evt);
    } else {
      evt.preventDefault();
      evt.stopPropagation();
      return false;
    }
  }

  onDoubleClick(evt) {
    if (!this.justClicked) {
      this.disallowClick();
      const clickHandler = this.props.onDoubleClick || this.props.onClick;
      clickHandler && clickHandler(evt);
    } else {
      evt.preventDefault();
      evt.stopPropagation();
      return false;
    }
  }

  render() {
    const propsToPass = Object.assign({}, this.props);
    propsToPass.onClick = this.onClick;
    propsToPass.type = this.props.type || "button";
    propsToPass.onDoubleClick = this.onDoubleClick;
    if (propsToPass.dataCy) {
      propsToPass["data-cy"] = propsToPass.dataCy;
      delete propsToPass.dataCy;
    }
    return <button {...propsToPass}>{this.props.children}</button>;
  }
}
